import React from 'react'
import { PureComponent } from 'react'
import { Redirect } from 'react-router-dom'
import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants'
import authService from './AuthorizeService'

export default class AuthorizeComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.isComponentMounted = false;
    this.state = {
      ready: false,
      authenticated: false
    };
  }

  componentDidMount() {
    this.isComponentMounted = true;
    this._subscription = authService.subscribe(() => this.authenticationChanged());
    this.populateAuthenticationState();
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
    this.isComponentMounted = false;
  }

  render() {
    const { ready, authenticated } = this.state;

    if (!ready) {
      return <div></div>;
    } else {
      const { component: PureComponent, ...rest } = this.props;

      if (authenticated)
        return <PureComponent {...rest} />
      else
        return <Redirect to={this.resolveRedirectUrl()} />
    }
  }

  resolveRedirectUrl() {
    var link = document.createElement("a");
    link.href = this.props.location.pathname;
    const returnUrl = `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
    return `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`
  }

  async populateAuthenticationState() {
    if (!this.isComponentMounted)
      return;

    const authenticated = await authService.isAuthenticated();
    this.setState({ ready: true, authenticated });
  }

  async authenticationChanged() {
    if (!this.isComponentMounted)
      return;

    this.setState({ ready: false, authenticated: false });
    await this.populateAuthenticationState();
  }
}
